<script>
import { BFormGroup } from 'bootstrap-vue'
import TreeSelect from "@core/components/common/TreeSelect.vue";
import ListOfObjects from "@/views/product/components/product-card/composition/components/ListOfObjects.vue";

export default {
    components: {TreeSelect, ListOfObjects, BFormGroup},
    props: {
        readOnly: {
            default: false,
        },
        value: {},
        config: {
            type: Object,
            default() {
                return {
                    data: []
                };
            }
        },
        applyWarningClass: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            treeselectMandatoryClass: 'treeselect-bg-warning',
        }
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
        }
    },
    computed: {
        mandatoryClass() {
            return this.applyWarningClass ? this.treeselectMandatoryClass : '';
        },
    }
}
</script>

<template>
    <div>
        <div v-if="readOnly">
            <h5>{{ $t('Component(CompositionSubstance):mixture-category') }}</h5>
            <div v-if="!value || value.length === 0">-</div>
            <ListOfObjects v-else :elements="value"/>
        </div>
        <b-form-group
            v-else
            :label="$t('Component(CompositionSubstance):mixture-category')"
        >
            <TreeSelect
                :title="$t('Component(CompositionSubstance):hover-mixture-category')"
                :placeholder="$t('Component(CompositionSubstance):mixture-category-placeholder')"
                :classes="mandatoryClass"
                :options="config.data"
                :value="value"
                @input="onInput"
            />
        </b-form-group>
    </div>
</template>
